export enum QueueActionType {
  Add = 'Add',
  Update = 'Update',
  Delete = 'Delete',
}
